<div class="spinner-wrapper" *ngIf="isLoading">
<div class="d-flex img-box position-relative">
  <div class="loadingio-spinner-spin-767img2n58c"><div class="ldio-nm1rz3j5ew">
    <div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div>
  </div></div>
</div>
</div>
